import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import ReactGA from "react-ga4";
Sentry.init({
  dsn: "https://8e9b60d038648681ddab3ae2a2cf6e8e@o4508969507684352.ingest.us.sentry.io/4508969508995072",
  tracesSampleRate: 1.0,
  environment: process.env.NODE_ENV,
});
function initializeAnalytics() {
  ReactGA.initialize("G-54G6KZZ1YH"); // Replace with your Measurement ID
}
initializeAnalytics();
const root = ReactDOM.createRoot(document.getElementById("root"));

// ✅ Wrap App inside BrowserRouter
root.render(<App />);
